"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AmplitudeCore = require("amplitude-js");
const state_1 = require("@airstudio/state");
class Amplitude extends state_1.Extensions.Abstract {
    constructor() {
        super();
        this.key = 'amplitude';
        state_1.Bus.onConfigReady(({ amplitude }) => {
            if (!amplitude) {
                // tslint:disable-next-line: no-console
                return console.warn('Amplitude extension is activated but backend config did not provide a `amplitude` value');
            }
            AmplitudeCore.getInstance().init(amplitude);
            this.dispatchSuccess({});
        });
        state_1.Bus.onUserReady(({ userId }) => {
            AmplitudeCore.getInstance().setUserId(userId);
        });
        state_1.Bus.onAnalytics(({ eventName, args, value }) => {
            AmplitudeCore.getInstance().logEvent(eventName, args);
            if (value) {
                AmplitudeCore.getInstance().logRevenueV2(new AmplitudeCore.Revenue().setPrice(value).setQuantity(1));
            }
        });
    }
}
exports.Amplitude = Amplitude;
//# sourceMappingURL=index.js.map